import React from 'react';
import { getSettingsMessage } from '../../shared/constants/pageMessages';
import styled from 'styled-components';
import { SubTitle, SubWrapper } from './MemberSetting';
import { StorageData } from '../../shared/dto/EntityRepository';
import { formatBytes } from '../../shared/util/formatBytes';

interface StorageProps {
  storageData: StorageData | null;
}

const Storage: React.FC<StorageProps> = ({ storageData }) => {
  if (!storageData) return null;
  
  const usagePercentage = (storageData.usedSize / storageData.maxSize) * 100;
  const formatUsedSize = formatBytes(storageData.usedSize, true);
  const formatMaxSize = formatBytes(storageData.maxSize, true);

  return (
    <SubWrapper>
      <SubTitle>{getSettingsMessage('SETTINGS_STORAGE')}
      </SubTitle>
      <StorageUsageContainer>
        <StorageBarContainer>
          <StorageBar>
            <StorageBarFill $usagePercentage={usagePercentage} />
          </StorageBar>
          <StorageText>
            {formatUsedSize} / {formatMaxSize}
          </StorageText>
        </StorageBarContainer>
      </StorageUsageContainer>
    </SubWrapper>
  );
}

const StorageUsageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

const StorageBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;


const StorageBar = styled.div`
  width: 100%;
  height: 5px;
  margin: 8px 0px;
  border-top: 0.5px solid ${({ theme }) => theme.colors.color_Gray_05};
  background-color: ${({ theme }) => theme.colors.color_Gray_06};
  border-radius: 1px;
  overflow: hidden;
  position: relative;
`;

const StorageBarFill = styled.div<{ $usagePercentage: number }>`
  width: ${({ $usagePercentage }) => Math.min($usagePercentage, 100)}%;
  height: 100%;
  background-color: ${({ theme, $usagePercentage }) => {
    if ($usagePercentage >= 95) return theme.colors.color_Gray_01;
    if ($usagePercentage >= 85) return theme.colors.color_Gray_02;
    if ($usagePercentage >= 70) return theme.colors.color_Gray_03;
    if ($usagePercentage >= 50) return theme.colors.color_Gray_04;
    return theme.colors.color_Gray_05;
  }};
  transition: width 0.3s ease;
`;

const StorageText = styled.div`
  width: fit-content;
  ${({ theme }) => theme.typography.Body_04};
`;



export default Storage; 